/**
 * Abstract class providing different Helper functions.
 * @abstract
 */
class Helper {
	/**
	 * Checks if given parameter is an object.
	 * @param {*} checkMe - Parameter to be checked.
	 * @returns {boolean} If parameter is an object.
	 * @static
	 */
	static isObject (checkMe) {
		return checkMe && checkMe.constructor.name === 'Object';
	}

	/**
	 * Clones an object.
	 * NO DEEP CLONING PROVIDED.
	 * @param {Object} cloneMe - Object to be cloned.
	 * @returns {Object} The Cloned object.
	 */
	// TODO Refactor: Allow deep cloning
	static cloneObject (cloneMe) {
		let clone = {};

		for (let key in cloneMe) {
			if (cloneMe.hasOwnProperty(key)) {
				clone[key] = cloneMe[key];
			}
		}

		return clone;
	}

	/**
	 * Merges given objects.
	 * @param {Object} mergeUs - Array of objects to be merged.
	 * @returns {Object} The merged Object.
	 */
	static mergeObjects (...mergeUs) {
		let merged = {};
		for (let mergeMe of mergeUs) {
			for (let key in mergeMe) {
				if (mergeMe.hasOwnProperty(key)) {
					merged[key] = mergeMe[key];
				}
			}
		}

		return merged;
	}

	/**
	 * Gets parameter from URL as a value.
	 * @param {string} param - Parameter to be read.
	 * @returns {string|number|null} Value of Parameter if parameter available. Null if parameter is not present. 0 if parameter has no value.
	 */
	static getUrlParam (param) {
		const results = new RegExp('[?&]' + param + '=([^]*)').exec(window.location.href);
		if (results === null) {
			return null;
		} else {
			return results[1] || 0;
		}
	}

	/**
	 * Returns parameter Object as an URL String.
	 * @param {Object} params - The Object containing the parameter keys and values.
	 * @returns {string} The URL string.
	 */
	static getParamsAsString (params) {
		const paramsArray = [];

		for (let key in params) {
			if (params.hasOwnProperty(key)) {
				if (typeof params[key] === 'function') {
					paramsArray.push(key + '=' + params[key]());
				} else {
					paramsArray.push(key + '=' + params[key]);
				}
			}
		}

		return paramsArray.join('&');
	}

	/**
	 * Checks if stage is live stage.
	 * @returns {boolean} If stage is 'live'.
	 */
	static isLiveStage () {
		return window.PageConfig.stage === 'live';
	}

	/**
	 * Checks if element does not have CSS display value of 'hidden'.
	 * @param {HTMLElement} element - The element to check.
	 * @returns {boolean} If the object is visible.
	 */
	static isElementVisible (element) {
		const style = window.getComputedStyle(element);
		return style.display !== 'none';
	}

	/**
	 * Reads first party cookie with given name.
	 * @param {string} cookieName - The Cookie name.
	 * @returns {string} The cookie Value. Empty if cookie not set.
	 */
	static getCookieValue (cookieName) {
		const findMe = '(?:^|; )' + cookieName + '=([^;]*)';
		return (document.cookie.match(findMe) || [0, ''])[1];
	}
}

export { Helper };
